module.exports = __webpack_public_path__ + "static/media/penguin_tile.3464de91.png";